app.searchBar = {
    settings: {
        el: document.querySelector('#search'),
        triggerOpen: '[data-search-open]',
        triggerClose: '[data-search-close]',
        input: document.querySelector('.search-bar__input')
    },

    init: function () {
        app.settings.$body.on('click', app.searchBar.settings.triggerOpen, function (event) {
            app.searchBar.settings.el.classList.remove('collapsed');

            setTimeout(function(){
            	app.searchBar.settings.input.focus();
            }, 300);

        });

        app.settings.$body.on('click', app.searchBar.settings.triggerClose, function (event) {
            app.searchBar.settings.el.classList.add('collapsed');
        });
    }
};